import { Checkbox, Grid } from "@mui/material";
import Divider from "@mui/material/Divider";
import CommonSelectWithoutNoneOption from "components/CommonSelect/selectWithoutNoneOption";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { companies, createUser, getUsersRoles, updateUser } from "rest/requests";
import swal from "sweetalert";

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const userHasRole = (userToEdit, role) => {
  if (!userToEdit || !Array.isArray(userToEdit.roles)) {   // Valida AMBOS
    return false;
  }
  const listUserRoles = userToEdit.roles.map((elem) => elem.id);  // ✅ seguro
  return listUserRoles.includes(role.id);
};

const changeUserRole = (roleId, rolesVisualisation, setRolesVisualisation) => {
  //rolesVisualisation[roleId] = !rolesVisualisation[roleId];
  const _temp = {};
  _temp[roleId] = !rolesVisualisation[roleId];
  setRolesVisualisation((rolesVisualisation) => ({
    ...rolesVisualisation,
    ..._temp,
  }));
};

const editUser = (
  setIsEditingUser,
  id,
  email,
  name,
  lastName,
  selectedCompanyEdit,
  roles,
  rolesVisualisation
) => {
  const body = {
    id: id,
    email: email,
    name: name,
    lastName: lastName,
    companyId: selectedCompanyEdit,
    active: 1,
    roles: roles.filter((role) => {
      return rolesVisualisation[role.id];
    }),
  };
  updateUser(id, body)
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Usuario actualizado exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating User: ", error);
    });
  setIsEditingUser(false);
};

const addUser = (
  password,
  setIsEditingUser,
  email,
  name,
  lastName,
  selectedCompanyEdit,
  roles,
  rolesVisualisation
) => {
  const body = {
    email: email,
    password: password,
    name: name,
    lastName: lastName,
    companyId: selectedCompanyEdit,
    active: 1,
    roles: roles.filter((role) => {
      return rolesVisualisation[role.id];
    }),
  };
  createUser(body)
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Usuario creado exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating User: ", error);
    });
  setIsEditingUser(false);
};

function EditUsers({ userToEdit, setIsEditingUser }) {
  const [email, setEmail] = useState(userToEdit ? userToEdit.email : "");
  const [name, setName] = useState(userToEdit ? userToEdit.name : "");
  const [lastName, setLastName] = useState(userToEdit ? userToEdit.lastName : "");
  const [password, setPassword] = useState("");

  const [selectedCompanyEdit, setSelectedCompanyEdit] = useState(
    userToEdit ? userToEdit.companyId : ""
  );
  const [companiesList, setCompaniesList] = useState([]);

  const [roles, setRoles] = useState([]);

  const getUsersData = useCallback(async () => {
    setCompaniesList(await companies());
  }, []);

  useEffect(() => {
    getUsersData();
  }, []);

  const getRolesData = useCallback(async () => {
    setRoles(await getUsersRoles());
  }, []);

  useEffect(() => {
    getRolesData();
  }, []);

  const [rolesVisualisation, setRolesVisualisation] = useState({});

  return (
    <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
      <Grid container marginTop={2}>
        <Grid item lg={6} minWidth={300}>
          <MDInput
            variant="outlined"
            type="email"
            label="Email"
            value={email}
            fullWidth={true}
            onChange={(event) => setEmail(event.target.value)}
            success={validateEmail(email)}
            error={!validateEmail(email)}
          />
        </Grid>
      </Grid>
      {userToEdit === null ? (
        <Grid container marginTop={2}>
          <Grid item lg={6} minWidth={300}>
            <MDInput
              variant="outlined"
              type="password"
              label="Contraseña (Minimo 8 letras)"
              value={password}
              fullWidth={true}
              onChange={(event) => setPassword(event.target.value)}
              success={password.length >= 8}
              error={password.length < 8}
            />
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
      <Grid container marginTop={2}>
        <Grid item lg={6} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Nombres"
            value={name}
            fullWidth={true}
            onChange={(event) => setName(event.target.value)}
            success={name != ""}
            error={name === ""}
          />
        </Grid>
      </Grid>
      <Grid container marginTop={2}>
        <Grid item lg={6} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Apellidos"
            value={lastName}
            fullWidth={true}
            onChange={(event) => setLastName(event.target.value)}
            success={lastName != ""}
            error={lastName === ""}
          />
        </Grid>
      </Grid>
      <Grid container marginTop={2}>
        <Grid item lg={6}>
          <CommonSelectWithoutNoneOption
            defaultValue={selectedCompanyEdit}
            label="Empresas"
            data={companiesList}
            onChange={(selectedValue) => setSelectedCompanyEdit(selectedValue)}
          ></CommonSelectWithoutNoneOption>
        </Grid>
      </Grid>
      <Divider></Divider>
      <Grid container marginTop={2}>
        <Grid item sm={6}>
          <MDBox variant="gradient" bgColor="info">
            <DataTable
              table={{
                columns: [
                  {
                    Header: "Seleccionado",
                    accessor: "Seleccionado",
                  },
                  {
                    Header: "Rol",
                    accessor: "Rol",
                  },
                  {
                    Header: "Descripción",
                    accessor: "Descripcion",
                  },
                ],
                rows: roles.map((userRole) => {
                  if (!(userRole.id in rolesVisualisation)) {
                    rolesVisualisation[userRole.id] = userHasRole(userToEdit, userRole);
                  }

                  //rolesVisualisation[userRole.id] = userHasRole(userToEdit, userRole);
                  //setRolesVisualisation(rolesVisualisation);
                  return {
                    Seleccionado: (
                      <Checkbox
                        checked={rolesVisualisation[userRole.id]}
                        onChange={() =>
                          changeUserRole(userRole.id, rolesVisualisation, setRolesVisualisation)
                        }
                      ></Checkbox>
                    ),
                    Rol: userRole.role,
                    Descripcion: userRole.description,
                  };
                }),
              }}
              canSearch={false}
              showTotalEntries={false}
              entriesPerPage={false}
            />
          </MDBox>
        </Grid>
      </Grid>

      <Grid container marginTop={2}>
        <Grid item padding={2}>
          <MDButton variant="outlined" color="info" onClick={() => setIsEditingUser(false)}>
            Atras
          </MDButton>
        </Grid>

        <Grid item padding={2}>
          {userToEdit ? (
            <MDButton
              variant="contained"
              color="info"
              onClick={() =>
                editUser(
                  setIsEditingUser,
                  userToEdit.id,
                  email,
                  name,
                  lastName,
                  selectedCompanyEdit,
                  roles,
                  rolesVisualisation
                )
              }
            >
              Actualizar
            </MDButton>
          ) : (
            <MDButton
              variant="contained"
              color="info"
              onClick={() =>
                addUser(
                  password,
                  setIsEditingUser,
                  email,
                  name,
                  lastName,
                  selectedCompanyEdit,
                  roles,
                  rolesVisualisation
                )
              }
            >
              Crear
            </MDButton>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default EditUsers;

EditUsers.defaultProps = {
  userToEdit: null,
  setIsEditingUser: null,
};

EditUsers.propTypes = {
  userToEdit: PropTypes.object,
  setIsEditingUser: PropTypes.func,
};
